import { render } from "./Bargraph.vue?vue&type=template&id=2258ffe0"
import script from "./Bargraph.vue?vue&type=script&lang=js"
export * from "./Bargraph.vue?vue&type=script&lang=js"

import exportComponent from "/home/utogplukkno/www.utogplukk.no/releases/78563473/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__